export default __webpack_public_path__ + "static/Graphik-RegularItalic-Web-fb3eb292272596fe24bf576fb52bb6da.woff";